module.exports = __webpack_public_path__ + "static/media/026.172e6abb.jpg";